import { NavItem } from "./Sidebar.types";

export const NAVIGATION_CONFIG: NavItem[] = [
  {
    id: "dashboard",
    label: "Painel Geral",
    icon: "lu-dashboard",
    path: "/admin-dashboard",
    shortcut: "G D",
  },
  {
    id: "support",
    label: "Central de Suporte",
    icon: "lu-suporte",
    path: "/support",
    shortcut: "G S",
  },
  {
    id: "virtual-manager",
    label: "Gerente Virtual",
    icon: "lu-comercial",
    path: "/sales-performance",
    children: [
      {
        id: "manager-dashboard",
        label: "Painel do Gerente",
        icon: "lu-dashboard",
        path: "/sales-performance",
      },
      {
        id: "distribution-admin",
        label: "Distribuição de Carteira",
        icon: "lu-distribuicao",
        path: "/distribution-admin",
      },
      {
        id: "client-buckets",
        label: "Baldes de Clientes",
        icon: "lu-buckets",
        path: "/marketing/client-buckets",
      },
      {
        id: "motor-triggers",
        label: "Gatilhos de Execução",
        icon: "lu-workflows",
        path: "/motor/triggers",
      },
      {
        id: "team-tasks",
        label: "Tarefas da Equipe",
        icon: "lu-tarefas",
        children: [
          {
            id: "tasks-list",
            label: "Todas as Tarefas",
            icon: "lu-list-todo",
            path: "/tasks",
          },
          {
            id: "tasks-categories",
            label: "Categorias de Tarefas",
            icon: "lu-list-filter",
            path: "/tasks/categories",
          },
          {
            id: "import-tasks",
            label: "Importar Tarefas Excel",
            icon: "lu-upload",
            path: "/store/import/tasks",
          },
        ],
      },
      {
        id: "opportunities",
        label: "Oportunidades",
        icon: "lu-oportunidades",
        path: "/opportunities",
      },
      {
        id: "seller-performance",
        label: "Performance dos Vendedores",
        icon: "lu-comercial",
        path: "/sales-performance",
        search: "?tab=clients",
      },
      {
        id: "sales-targets",
        label: "Metas Comerciais",
        icon: "lu-award",
        path: "/sales-performance",
        search: "?tab=targets",
      },
      {
        id: "sales-ranking",
        label: "Ranking Comercial",
        icon: "lu-award",
        path: "/sales-performance",
        search: "?tab=ranking",
      },
      {
        id: "landing-page-sales-audit",
        label: "Auditoria de Vendas",
        icon: "lu-scan-search",
        path: "/store/landing-page/sales-audit",
      },
    ],
  },
  {
    id: "commercial-clients",
    label: "Comercial e Clientes",
    icon: "lu-cadastro",
    path: "/register/clients-v2",
    shortcut: "G C",
    children: [
      {
        id: "clients-v2",
        label: "Clientes",
        icon: "lu-users-round",
        path: "/register/clients-v2",
      },
      {
        id: "client-groups",
        label: "Grupos de Clientes",
        icon: "lu-users-round",
        path: "/register/clients/groups",
      },
      {
        id: "buyers",
        label: "Compradores",
        icon: "lu-user-round",
        path: "/register/buyers",
      },
      {
        id: "sellers",
        label: "Equipe Comercial",
        icon: "lu-handshake",
        path: "/register/sellers",
      },
      {
        id: "dindin",
        label: "Recompensas DinDin",
        icon: "lu-dindin",
        path: "/dindin",
      },
      {
        id: "register-suppliers",
        label: "Representadas",
        icon: "lu-building",
        path: "/register/suppliers/all",
      },
    ],
  },
  {
    id: "orders-operations",
    label: "Pedidos e Operação",
    icon: "lu-shopping-cart",
    path: "/store/pedidos",
    children: [
      {
        id: "orders-list",
        label: "Pedidos",
        icon: "lu-shopping-cart",
        path: "/store/pedidos",
      },
      {
        id: "import-xml",
        label: "Importar XML",
        icon: "lu-file-up",
        path: "/finances/import-xml",
      },
      {
        id: "import-faturamento",
        label: "Faturamento Excel",
        icon: "lu-file-spreadsheet",
        path: "/finances/import-excel-faturamento",
      },
      {
        id: "orders-invoices",
        label: "Faturas dos Pedidos",
        icon: "lu-file-spreadsheet",
        path: "/finances/invoices-management",
      },
    ],
  },
  {
    id: "finances",
    label: "Financeiro",
    icon: "lu-financeiro",
    path: "/finances",
    shortcut: "G F",
    children: [
      {
        id: "finances-dashboard",
        label: "Painel Financeiro",
        icon: "lu-dashboard",
        path: "/finances",
      },
      {
        id: "finances-orders",
        label: "Títulos a Receber",
        icon: "lu-titulos",
        path: "/finances/orders",
      },
      {
        id: "invoice-billet-tags",
        label: "Marcadores Financeiros",
        icon: "lu-tags",
        path: "/finances/invoice-billet-tags",
      },
      {
        id: "titles-management",
        label: "Gestão de Títulos",
        icon: "lu-titulos",
        path: "/finances/titles-management",
      },
      {
        id: "receipt-authorization",
        label: "Autorizações de Recebimento",
        icon: "lu-shield-check",
        path: "/finances/receipt-authorization",
      },
      {
        id: "import-titulos",
        label: "Importar Títulos",
        icon: "lu-file-up",
        path: "/finances/import-excel-titulos",
      },
    ],
  },
  {
    id: "marketing",
    label: "Marketing e Ativação",
    icon: "lu-marketing",
    path: "/marketing",
    shortcut: "G M",
    children: [
      {
        id: "marketing-dashboard",
        label: "Painel de Marketing",
        icon: "lu-dashboard",
        path: "/marketing",
      },
      {
        id: "segments",
        label: "Públicos e Segmentos",
        icon: "lu-segments",
        path: "/marketing/segments",
      },
      {
        id: "marketing-tags",
        label: "Tags de Marketing",
        icon: "lu-tags",
        path: "/marketing/tags",
      },
      {
        id: "campaigns",
        label: "Campanhas",
        icon: "lu-campaigns",
        path: "/marketing/campaigns",
      },
      {
        id: "templates",
        label: "Modelos de Mensagem",
        icon: "lu-templates",
        path: "/marketing/templates",
      },
      {
        id: "workflows",
        label: "Jornadas Automáticas",
        icon: "lu-workflows",
        path: "/marketing/workflows",
      },
      {
        id: "newsletter",
        label: "Newsletter",
        icon: "lu-newsletter",
        path: "/marketing/newsletter",
      },
    ],
  },
  {
    id: "store",
    label: "Loja, Catálogo e Produtos",
    icon: "lu-loja",
    path: "/store/products",
    shortcut: "G L",
    children: [
      {
        id: "products",
        label: "Produtos",
        icon: "lu-package",
        path: "/store/products",
      },
      {
        id: "sales",
        label: "Pedidos da Loja",
        icon: "lu-shopping-cart",
        path: "/store/sales",
      },
      {
        id: "store-suppliers",
        label: "Fornecedores / Representadas",
        icon: "lu-building",
        path: "/store/suppliers",
      },
      {
        id: "tags",
        label: "Tags de Produtos",
        icon: "lu-tags",
        path: "/store/tags",
      },
      {
        id: "cupons",
        label: "Cupons",
        icon: "lu-ticket",
        path: "/store/cupons",
      },
      {
        id: "categories",
        label: "Categorias",
        icon: "lu-folder-tree",
        path: "/store/categories",
      },
      {
        id: "brands",
        label: "Marcas",
        icon: "lu-star",
        path: "/store/brands",
      },
      {
        id: "highlight",
        label: "Imagens de Destaque",
        icon: "lu-image",
        path: "/store/highlight_images",
      },
      {
        id: "attributes",
        label: "Atributos",
        icon: "lu-sliders",
        path: "/store/attributes",
      },
      {
        id: "import-state-prices",
        label: "Preços por Estado",
        icon: "lu-map-pin",
        path: "/store/import/state-prices",
      },
      {
        id: "landing-page",
        label: "Landing Page",
        icon: "lu-globe",
        path: "/store/landing-page",
      },
      {
        id: "client-storefronts",
        label: "E-commerce dos Clientes",
        icon: "lu-store",
        path: "/store/client-storefronts",
      },
    ],
  },
  {
    id: "intelligence-rules",
    label: "Inteligência e Regras",
    icon: "lu-motores",
    path: "/cnae-enrichments",
    children: [
      {
        id: "cnae-enrichment",
        label: "CNAE e Perfil de Loja",
        icon: "lu-building2",
        path: "/cnae-enrichments",
      },
      {
        id: "supplier-enrichment",
        label: "Regras por Fornecedor",
        icon: "lu-truck",
        path: "/supplier-enrichment",
      },
      {
        id: "coupon-engine",
        label: "Regras de Cupons",
        icon: "lu-ticket",
        path: "/coupon-engine",
      },
    ],
  },
  {
    id: "lara-ativa",
    label: "Lara Ativa",
    icon: "lu-bot",
    path: "/lara-ia/prompt-bases",
    children: [
      {
        id: "lara-prompt-bases",
        label: "Base de Prompts",
        icon: "lu-prompt",
        path: "/lara-ia/prompt-bases",
      },
      {
        id: "lara-generated-messages",
        label: "Mensagens Geradas",
        icon: "lu-sparkles",
        path: "/lara-ia/generated-messages",
      },
    ],
  },
  {
    id: "lara-reativa",
    label: "Lara Reativa",
    icon: "lu-message-circle",
    path: "/whatsapp-assistant/conversations",
    children: [
      {
        id: "lara-reativa-conversations",
        label: "Conversas",
        icon: "lu-message-circle",
        path: "/whatsapp-assistant/conversations",
      },
    ],
  },
  {
    id: "seller-client-chat",
    label: "Gerenciador de Chat",
    icon: "lu-contact-round",
    path: "/seller-client-chat/conversations",
    children: [
      {
        id: "seller-client-chat-conversations",
        label: "Vendedor ↔ Cliente",
        icon: "lu-layout-list",
        path: "/seller-client-chat/conversations",
      },
      {
        id: "seller-admin-chat-conversations",
        label: "Admin ↔ Vendedor",
        icon: "lu-contact-round",
        path: "/seller-client-chat/admin/conversations",
      },
      {
        id: "admin-peer-chat-conversations",
        label: "Admin ↔ Admin",
        icon: "lu-user-round",
        path: "/seller-client-chat/admin-peer/conversations",
      },
    ],
  },
  {
    id: "imports-exports",
    label: "Importações e Exportações",
    icon: "lu-folder-up",
    path: "/store/import",
    children: [
      {
        id: "import-products",
        label: "Importar Produtos Excel",
        icon: "lu-package-plus",
        path: "/store/import",
      },
      {
        id: "import-products-v2",
        label: "Importar Produtos V2",
        icon: "lu-file-spreadsheet",
        path: "/store/import/v2",
      },
      {
        id: "import-products-v2-profiles",
        label: "Perfis Importação V2",
        icon: "lu-bookmark",
        path: "/store/import/v2/profiles",
      },
      {
        id: "import-catalog",
        label: "Importação de Produtos",
        icon: "lu-folder-input",
        path: "/store/import/catalog",
      },
      {
        id: "import-product-images",
        label: "Importar Imagens",
        icon: "lu-images",
        path: "/store/import/images",
      },
      {
        id: "import-clients",
        label: "Importar Clientes Excel",
        icon: "lu-user-plus",
        children: [
          {
            id: "import-clients-maintenance",
            label: "Manutenção em massa",
            icon: "lu-pencil",
            path: "/store/import/clients",
          },
          {
            id: "import-clients-external",
            label: "Base externa nova",
            icon: "lu-cloud-upload",
            path: "/store/import/clients/external",
          },
        ],
      },
      {
        id: "export-clients",
        label: "Exportar Clientes",
        icon: "lu-file-down",
        path: "/store/export/clients",
      },
      {
        id: "export-products",
        label: "Exportar Produtos",
        icon: "lu-package-check",
        path: "/store/export/products",
      },
    ],
  },
  {
    id: "site-content",
    label: "Conteúdo do Site",
    icon: "lu-blog",
    path: "/blog/posts",
    shortcut: "G B",
    children: [
      {
        id: "posts",
        label: "Postagens",
        icon: "lu-pen-line",
        path: "/blog/posts",
      },
      {
        id: "author",
        label: "Autores",
        icon: "lu-user-pen",
        path: "/blog/author",
      },
      {
        id: "blog-category",
        label: "Categorias do Blog",
        icon: "lu-folder-open",
        path: "/blog/category",
      },
      {
        id: "banners",
        label: "Banners",
        icon: "lu-presentation",
        path: "/register/banners",
      },
      {
        id: "banner-library",
        label: "Biblioteca de Banners",
        icon: "lu-images",
        path: "/register/banner-library",
      },
      {
        id: "vcard",
        label: "Cartões Digitais / vCards",
        icon: "lu-credit-card",
        path: "/register/vcard",
      },
      {
        id: "client-catalog",
        label: "Origens e Tipos de Loja",
        icon: "lu-store",
        path: "/settings/client-catalog",
      },
    ],
  },
  {
    id: "settings",
    label: "Configurações do Sistema",
    icon: "lu-config",
    path: "/register/admin",
    children: [
      {
        id: "admin",
        label: "Usuários e Administradores",
        icon: "lu-crown",
        path: "/register/admin",
      },
      {
        id: "shipping",
        label: "Transportadoras",
        icon: "lu-truck",
        path: "/register/shipping",
      },
      {
        id: "site-info",
        label: "Informações do Site",
        icon: "lu-globe",
        path: "/settings/info",
      },
      {
        id: "sitemap",
        label: "Mapa do Site",
        icon: "lu-map",
        path: "/settings/map",
      },
      {
        id: "client-api-scripts",
        label: "Scripts de Integração",
        icon: "lu-file-code",
        path: "/settings/client-api-scripts",
      },
    ],
  },
];

export function flattenNavigation(items: NavItem[]): NavItem[] {
  return items.reduce<NavItem[]>((acc, item) => {
    acc.push(item);
    if (item.children) {
      acc.push(...flattenNavigation(item.children));
    }
    return acc;
  }, []);
}

export function getNavItemTo(item: NavItem): string | { pathname: string; search: string } {
  if (!item.path) return "#";

  if (item.search) {
    return { pathname: item.path, search: item.search };
  }

  return item.path;
}

function normalizePathname(path: string): string {
  return path.replace(/\/$/, "") || "/";
}

function getTabFromSearch(search: string): string | null {
  return new URLSearchParams(search).get("tab");
}

function pathsMatch(itemPath: string, currentPath: string): boolean {
  const item = normalizePathname(itemPath);
  const current = normalizePathname(currentPath);

  if (item === "/store/import") {
    return current === item || current === `${item}/new`;
  }

  if (item === "/store/import/clients") {
    return current === item;
  }

  if (item === "/store/landing-page") {
    return current === item;
  }

  if (current === item) return true;

  return current.startsWith(`${item}/`);
}

export function isNavItemActive(
  item: Pick<NavItem, "path" | "search">,
  currentPath: string,
  currentSearch: string,
): boolean {
  if (!item.path || !pathsMatch(item.path, currentPath)) return false;

  const itemTab = item.search ? getTabFromSearch(item.search) : null;
  const currentTab = getTabFromSearch(currentSearch);

  if (itemTab) {
    return itemTab === currentTab;
  }

  if (normalizePathname(item.path) === "/sales-performance") {
    return !currentTab || currentTab === "intelligence";
  }

  return true;
}

export function isPathActive(
  path: string,
  currentPath: string,
  exact: boolean = false,
): boolean {
  const [pathBase, pathQuery = ""] = path.split("?");
  const [currentBase, currentQuery = ""] = currentPath.split("?");

  if (normalizePathname(pathBase) !== normalizePathname(currentBase)) {
    if (exact) return false;
    return currentBase.startsWith(pathBase + "/");
  }

  if (pathQuery) {
    const expected = new URLSearchParams(pathQuery);
    const actual = new URLSearchParams(currentQuery);
    let matches = true;

    expected.forEach((value, key) => {
      if (actual.get(key) !== value) {
        matches = false;
      }
    });

    return matches;
  }

  if (exact && currentQuery) return false;

  return true;
}

export function isGroupActive(
  item: NavItem,
  currentPath: string,
  currentSearch = "",
): boolean {
  if (item.children?.length) {
    const childActive = item.children.some((child) =>
      isGroupActive(child, currentPath, currentSearch),
    );

    if (childActive) return true;

    if (item.path) {
      return isNavItemActive(item, currentPath, currentSearch);
    }

    return false;
  }

  if (item.path) {
    return isNavItemActive(item, currentPath, currentSearch);
  }

  return false;
}
